import { Injectable } from '@angular/core'
import { InstalledModule } from '../../models/login-response.model'
import { TopMenuItem } from './menu.service.config'

@Injectable({
  providedIn: 'root',
})
export class TopMenuService {

  public hasAccessToItemByRole(item: TopMenuItem, role: string): boolean {
    return this.getRolesFromMenuItem(item).indexOf(role) !== -1
  }

  // All modules in the menu item must be installed in order to have access
  public hasAccessToItemByModules(
    item: TopMenuItem,
    installedModules: InstalledModule[]
  ): boolean {
    const menuItemModules: { name: string; display: boolean }[] = this.getModulesFromMenuItem(item)

    if (installedModules.length === 0 && menuItemModules.length > 0) {
      return false;
    }

    const installedModuleSet = new Set(installedModules.map((m) => m.name))

    for (const menuItemModule of menuItemModules) {
      if (!installedModuleSet.has(menuItemModule.name)) {
        item['_display'] = menuItemModule.display ?? true

        return false
      }
    }

    return true
  }

  private getRolesFromMenuItem(item: TopMenuItem): string[] {
    return (item.roles ?? []) as string[]
  }

  private getModulesFromMenuItem(item: TopMenuItem): { name: string; display: boolean }[] {
    return (item.modules ?? []).map((item) => {
      return {
        name: item.name,
        display: item.display ?? true,
      }
    })
  }
}
